import React from 'react'

import cx from 'classnames'

import './styles.css'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isSelected: boolean
}

const ChipButton: React.FC<Props> = ({
  className,
  isSelected,
  children,
  ...props
}) => (
  <button
    className={cx('chip-button', className, {
      'chip-button--selected': isSelected,
    })}
    {...props}
  >
    {children}
  </button>
)

export default ChipButton
